/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateVariantRequestPartial } from '../../models/update-variant-request-partial';
import { UpdateVariantResponse } from '../../models/update-variant-response';

export interface VariantsControllerPatchVariant$Params {

/**
 * Variant id.
 */
  id: string;
  
    /**
     * Patching request - contains only fields to be modified.
     */
    body?: UpdateVariantRequestPartial
}

export function variantsControllerPatchVariant(http: HttpClient, rootUrl: string, params: VariantsControllerPatchVariant$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateVariantResponse>> {
  const rb = new RequestBuilder(rootUrl, variantsControllerPatchVariant.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateVariantResponse>;
    })
  );
}

variantsControllerPatchVariant.PATH = '/planning-projects/v1-preview/projects/variants/{id}';
